<template>
  <div class="container fx-sta-cen fx-col">
    <img src="../../assets/img/yuan.png" style="margin-top: 50px;width: 160px;height: 160px"/>

    <div style="color: #323233;font-weight: bold;font-size: 18px;margin-top: 60px">
      {{ deliveryName ? deliveryName : '快递尚未发出' }}
    </div>

    <div class="fx-cen-cen" style="font-size: 16px;margin-top: 36px">
      <div style="color: #979797">快递单号：</div>
      <div style="color: #FF7216">{{ deliveryNumber ? deliveryNumber : '快递尚未发出' }}</div>
    </div>

    <div class="fx1"></div>
    <div id="copy" class="fx-cen-cen"
         @click="copy"
         v-if="deliveryNumber"
         style="background: #FF7216;color: #FFF;height: 44px;width: 240px;font-size: 16px;border-radius: 8px">复制单号
    </div>
    <div @click="back" style="font-size: 16px;height: 44px;width: 240px;margin-bottom: 60px;margin-top: 35px"
         class=" btn fx-cen-cen">
      返回
    </div>

  </div>


</template>

<script>
import ClipboardJS from 'clipboard'

export default {
  name: 'MyDelivery',
  data() {
    return {
      deliveryName: '',
      deliveryNumber: '',
    }
  },
  created(option) {
    this.$http.post('/spInfo/userInfo', {id: this.$route.query.id}).then(res => {
      if (res.data) {
        this.deliveryName = res.data.deliveryName
        this.deliveryNumber = res.data.deliveryNumber
      } else {
        this.$toast("未查询到信息")
      }
    })


  },
  activated() {
  },
  methods: {
    back() {
      this.$router.back()
    },
    copy() {
      const clipboard = new ClipboardJS('#copy', {
        text: trigger => {
          this.$toast("复制成功")
          return this.deliveryNumber
        }
      })
      clipboard.on('error', e => {
        this.$toast("复制失败")
      })
    }
  }
}
</script>

<style lang="less" scoped>
.container {
  width: 100%;
  height: 100vh;
  background-color: #FFFFFF;
}

.btn {
  width: 220px;
  height: 40px;
  color: #FF7216;
  border-radius: 5px;
  font-size: 18px;
  border: 1px solid #FF7216;
  background: #FFF;
}

</style>



// WEBPACK FOOTER //
// src/routerPages/info/MyDelivery.vue